/**
 * When "call the year" applies (ADR-0040, revising OD5-1's "first" for round 1): a player has nothing to call from before the first
 * year's results, so the call, its gating of the preview and its scoring start at round 2.
 */
export const FIRST_CALL_ROUND = 2;

export const callRequiredIn = (roundNo: number): boolean => roundNo >= FIRST_CALL_ROUND;
